import classNames from 'classnames';
import { getBackgroundProp, resolveSetting } from '../../../utils/settingsHelper';
import { roundedOptions, shadowOptions } from '../../editor/Toolbar/options';

export const getDivStyle = (props, settings) => {
	const { borderWidth, borderColor, color, flexDirection, alignItems, padding } = props;
	return {
		color: resolveSetting(color, settings),
		background: getBackgroundProp(props, settings),
		borderColor: resolveSetting(borderColor, settings),
		borderWidth: `${resolveSetting(borderWidth, settings)}px`,
		display: 'flex',
		alignItems,
		flexDirection,
		padding: padding ? `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px` : '',
	};
};

export const getDivClasses = (props, settings) => classNames('flex', { [roundedOptions[resolveSetting(props.rounded, settings)]]: !!resolveSetting(props.rounded, settings) }, shadowOptions[props.shadow], { 'overflow-hidden': props.overflowHidden });
